<template>
    <div class="container_cool" v-loading="login_loading" element-loading-text="页面加载中..."  element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="cool_bg" v-if="is_start">
            <div class="cool_detail" >
                <div class="detail_left" style="width:100%">
                    <div class="detail_content">
                        <mavon-editor
                            :tabSize="4"
                            fontSize="20px"
                            :value="detail.title"
                            :subfield="false"
                            :defaultOpen="'preview'"
                            :toolbarsFlag="false"
                            :editable="false"
                            :scrollStyle="true"
                            :ishljs="true"
                            ref="md"
                            style="box-shadow: none !important;height:100%">
                        </mavon-editor>
                    </div>
                    <div class="detail_options">
                        <div class="options_pan" v-if="detail.type == 3">
                            <div><div :class="check == 2?'icon_box check':'icon_box'" @click="getPanDuan(2)"><span class="el-icon-check"></span></div></div>
                            <div><div :class="check == 1?'icon_box check':'icon_box'" @click="getPanDuan(1)"><span class="el-icon-close"></span></div></div>
                        </div>
                        <div class="option_xuan" v-if="detail.type == 0">
                            <div v-for="(item,index) in detail.options" :key="index" :class="active == (index+1)?'active':''"  @click="getDanXuan(item,index)">
                                <div class="idx">{{item.idx}}:</div>
                                <div>
                                    <mavon-editor
                                        :tabSize="4"
                                        fontSize="20px"
                                        :value="item.content"
                                        :subfield="false"
                                        :defaultOpen="'preview'"
                                        :toolbarsFlag="false"
                                        :editable="false"
                                        :scrollStyle="true"
                                        :ishljs="true"
                                        ref="md"
                                        style="box-shadow: none !important;min-height:100px;max-height:110px;">
                                    </mavon-editor>
                                </div>
                            </div>
                        </div>
                        <div class="option_more_xuan" v-if="detail.type == 1">
                            <div v-for="(item,index) in detail.options" :key="index" :class="xuan[index] == 1?'active':''" @click="getMoreXuan(index)">
                                <div class="idx">{{item.idx}}:</div>
                                <div>
                                    <mavon-editor
                                        :tabSize="4"
                                        fontSize="20px"
                                        :value="item.content"
                                        :subfield="false"
                                        :defaultOpen="'preview'"
                                        :toolbarsFlag="false"
                                        :editable="false"
                                        :scrollStyle="true"
                                        :ishljs="true"
                                        ref="md"
                                        style="box-shadow: none !important;min-height:100px;max-height:110px;">
                                    </mavon-editor>
                                </div>
                            </div>
                        </div>
                        <div class="option_tian" v-if="detail.type == 2">
                            <div class="tian_ipt_box" v-for="(item,index) in detail.ans_cnt" :key="index"><input :class="'tian_ipt tian_ipt'+index" type="text" :placeholder="'('+ (index+1) +')'"></div>
                        </div>
                    </div>
                    <div class="detail_bottom">
                        <div class="click_start" :style="'right:'+ lett_lr +'%;'"  v-if="start_answer" @click="submit">提交</div>
                    </div>
                </div>
            </div>
        </div>      
        <div class="cool_bg" v-if="is_wait">
           <div class="cool_wait_box">
               <div class="cool_wait_img">
                   <img src="../static/images/kddt.png" alt="">
                   <div class="start_btn">等待答题</div>
                </div>
               
           </div>
        </div>        
        <div class="cool_end_bg" v-if="is_end">
           <div class="cool_end_pai"></div>
           <div class="cool_end_img">
               <div class="cool_end_answer">正确答案：
                    <span v-for="(item,index) in answers" :key="index" style="margin-right:10px;">
                        <span v-if="item == 0">对</span>
                        <span v-else-if="item == 1">错</span>
                        <span v-else>{{item}}</span>
                    </span>
                </div>
               <div class="cool_end_list">
                    <div class="cool_end_item" v-for="(item,index) in result" :key="index">
                        <div class="number" v-if="index == 0">
                            <img src="../static/images/1.png" alt="">
                        </div>
                        <div class="number" v-else-if="index == 1">
                            <img src="../static/images/2.png" alt="">
                        </div>
                        <div class="number" v-else-if="index == 2">
                            <img src="../static/images/3.png" alt="">
                        </div>
                        <div class="number" v-else><span>{{(index+1)}}}</span></div>
                        <div class="avatar"><img :src="item.avatar" alt=""></div>
                        <div class="name" style="width:100px;text-align: left;">{{item.name}}</div>
                        <div class="score">{{item.score}}</div>
                        <div class="jinbi"><img src="../static/images/jinbi.png" alt=""></div>
                        <div class="num">x{{item.coin}}</div>
                    </div>
               </div>
           </div>
        </div>  
    </div>
</template> 

<style>
    .option_xuan .markdown-body pre{
        padding: 0 !important;
    }   
    .option_xuan .v-note-wrapper .v-note-panel .v-note-show .v-show-content{
        height: inherit !important;
        padding: 0 !important;
    }
    .option_xuan .hljs{
        padding: 0 !important;
    }
    .option_xuan .markdown-body code{
        font-size: 18px;
    }
    .idx{
        font-size: 24px;
        font-weight: bold;
        margin-right: 10px;
    }
</style>
<script>
import $ from "jquery";
import "mavon-editor/dist/css/index.css";
import io from 'socket.io-client';
var timeOut = null;
export default {
    name: "cool",
    data() {
        return {
            login_loading:true,
            httpApi:'wss://datiadmin.kuding.cn',
            // httpApi:"ws://192.168.0.110:5200",
            websock:null,
            token:'',
            lid:'',
            detail:'',
            is_start:false,
            is_wait:true,
            is_end:false,
            start_answer:false,
            check:'',
            active:'',
            more_option:[
                {text:'选项A',value:'A'},
                {text:'选项B',value:'B'},
                {text:'选项C',value:'C'},
                {text:'选项D',value:'D'},
                {text:'选项E',value:'E'},
                {text:'选项F',value:'F'},
            ],
            xuan:[],
            answers:[],
            result:[],
            pan_answer:[],
            dan_answer:[],
            more_answer:'',
            tian_answer:[],
            user_id:0,
            my_answer:'',
            lett_lr:0,
            example_id:0,
            websocket:null,
            countNumber:0,
            show_time_text:'',
        };
    },
    created() {
        this.lett_lr = this.randomNum(1,100);
        this.token = this.$route.query.token;
        this.lid = this.$route.query.lid;
    },
    mounted() {
        this.initWebscoket();
    },
    methods: {
        randomNum(minNum,maxNum){ 
            switch(arguments.length){ 
                case 1: 
                    return parseInt(Math.random()*minNum+1,10); 
                break; 
                case 2: 
                    return parseInt(Math.random()*(maxNum-minNum+1)+minNum,10); 
                break; 
                    default: 
                        return 0; 
                    break; 
            } 
        },
        initWebscoket() {
            let self = this;
            self.websocket = io(self.httpApi + '/dati', {
                query: "token=" + self.token + "&lesson_id=" + self.lid,
                transports: ['websocket', 'polling'],
                timeout: 5000,
                reconnectionDelay: 3000,
                reconnectionAttempts: 10,
            });
            self.websocket.io.on("reconnect_attempt", (attempt) => {
                if (attempt < 10) {
                    let data = '服务断开，正在重新尝试链接...'
                    self.$message({
                        type: "error",
                        duration: 2000,
                        message: data,
                    });
                    self.websocket.io.opts.extraHeaders = {
                        token: that.token,
                        lesson_id: that.lid
                    };
                } else {
                    let data = '服务重新链接失败';
                    self.$message({
                        type: "error",
                        duration: 2000,
                        message: data,
                    });
                }
            });
            self.websocket.io.on("reconnect", () => {
                let data = '重新链接成功！';
                self.$message({
                    type: "success",
                    duration: 2000,
                    message: data,
                });
            });
            self.websocket.on("error", (data) => {
                self.$message({
                    type: "error",
                    duration: 2000,
                    message: data,
                });
            });
         
            self.websocket.on("login_success", (data) => {
                self.loginSuccess(JSON.stringify(data))
            });
            self.websocket.on("on_statistic", (data) => {
                self.onStatistic(JSON.stringify(data))
            });
            self.websocket.on("on_push_example", (data) => {
                self.onPushExample(JSON.stringify(data))
            });
            // self.websocket.on("on_user_answer", (data) => {
            //     self.onUserAnswer(JSON.stringify(data))
            // });
            self.websocket.on("on_correct", (data) => {
                self.onCorrect(JSON.stringify(data))
            });
            self.websocket.on("on_callback", (data) => {
                self.onCallback(JSON.stringify(data))
            });
        },
        
        loginSuccess(data){
            this.user_id = JSON.parse(data).user_info.user_id;
            this.login_loading = false;
        },
        onCallback(data){//返回
            this.is_wait = true;
            this.is_start = false;
            this.is_end = false;
            this.detail = '';
            this.answers = [];
            this.result = [];
            this.active = '';
            this.xuan = [];
            this.check = '';
            this.tian_answer = [];
            this.start_answer = false;
        },
        onCorrect(data){//订正
           this.detail = JSON.parse(data).example;
            if(this.detail.type == 1){
                this.xuan = [];
                for(var i = 0;i<this.detail.options.length;i++){
                    this.xuan.push(0)
                }
            }
            this.is_wait = false;
            this.is_start = true;
            this.is_end = false;
            this.start_answer = false;
        },
        onStatistic(data){//数据统计
            this.is_wait = false;
            this.is_start = false;
            this.is_end = true;
            this.answers = [];
            this.result = [];
            this.answers = JSON.parse(data).statistic.answers;
            this.result = JSON.parse(data).statistic.result;
            this.active = '';
            this.xuan = [];
            this.check = '';
            this.tian_answer = [];
            for(var i = 0;i<this.result.length;i++){
                if(this.user_id == this.result[i].user_id){
                    this.my_answer = this.result[i];
                }
            }
        },
        // onUserAnswer(data){//学生提交完成
        //     this.start_answer = false;
        // },
        onPushExample(data){//学生获取题目
            this.detail = JSON.parse(data).example;
            if(this.detail.type == 1){
                this.xuan = [];
                for(var i = 0;i<this.detail.options.length;i++){
                    this.xuan.push(0)
                }
            }
            this.start_answer = true;
            this.is_wait = false;
            this.is_start = true;
            this.is_end = false;
            // this.countNumber = this.detail.remain;
            // this.show_time_text = this.formatSeconds(JSON.parse(data).remain);
            // let self = this;
            // setTimeout(() => {
            //     self.getShowTime();
            // }, 1000);
        },
        getShowTime(){
            if(this.countNumber > 1){
                this.countNumber = this.countNumber - 1;
                this.show_time_text = this.formatSeconds(this.countNumber);
                let self = this;
                timeOut = setTimeout(() => {
                    self.getShowTime();
                }, 1000);
            }else{
                let answers = '';
                if(this.detail.type == 0){
                    if(this.dan_answer.length == 0){
                        this.start_answer = false;
                    }else{
                        answers = this.dan_answer;
                    }
                }
                if(this.detail.type == 1){
                    if(this.more_answer === ''){
                        this.start_answer = false;
                    }else{
                        answers = this.more_answer.split("");
                    }
                }
                if(this.detail.type == 2){
                    this.tian_answer = [];
                    for(var i = 0;i<$('.tian_ipt').length;i++){
                        this.tian_answer.push($('.tian_ipt')[i].value)
                    }
                    if(this.tian_answer.length == 0){
                        this.start_answer = false;
                    }else{
                        answers = this.tian_answer;
                    }
                }
                if(this.detail.type == 3){
                    if(this.pan_answer.length == 0){
                        this.start_answer = false;
                    }else{
                        answers = this.pan_answer;
                    }
                }
                this.websocket.emit("user_answer",this.detail.id,JSON.stringify(answers));
            }
        },
        formatSeconds(value) {
            var theTime = parseInt(value); // 秒
            var middle = 0; // 分
            var hour = 0; // 小时
            if (theTime > 60) {
                middle = parseInt(theTime / 60);
                theTime = parseInt(theTime % 60);
                if (middle > 60) {
                    hour = parseInt(middle / 60);
                    middle = parseInt(middle % 60);
                }
            } 
            var result = ''
            if (parseInt(theTime) >= 10) {
                result = "00" + ":" + parseInt(theTime);
            } else {
                result  = "00" + ":" + "0" + parseInt(theTime);
            }
            if (middle >= 0 && parseInt(theTime) >= 10) {
                if (parseInt(middle) >= 10) {
                    result = parseInt(middle) + ":" + parseInt(theTime);
                } else {
                    result = '0' + parseInt(middle) + ":" + parseInt(theTime);
                }
            } else {
                result = '0' + parseInt(middle) + ":" + "0" + parseInt(theTime);
            }
            return result;
        },
        //选项相关操作
        getPanDuan(type){
            this.check = type;
            this.pan_answer = [];
            if(type == 2){
                this.pan_answer.push(0)
            }else{
                this.pan_answer.push(1)
            }
        },
        getDanXuan(item,index){
            this.active = (index+1);
            this.dan_answer = [];
            this.dan_answer.push(item.idx)
        },
        getMoreXuan(index){
            if(this.xuan[index] == 0){
                this.xuan[index] = 1;
            }else{
                this.xuan[index] = 0;
            }
            this.more_answer = '';
            for(var i = 0;i<this.xuan.length;i++){
                if(this.xuan[i] == 1){
                   this.more_answer = this.more_answer + this.detail.options[i].idx;
                }
            }
            console.log(this.more_answer)
            this.$forceUpdate();
        },
        //提交答案
        submit(){
            let answers = '';
            if(this.detail.type == 0){
                if(this.dan_answer.length == 0){
                    this.$message({
                        type: "error",
                        duration: 1500,
                        message: '请先选择答案'
                    });
                    return false;
                }else{
                    answers = this.dan_answer;
                }
            }
            if(this.detail.type == 1){
                if(this.more_answer === ''){
                    this.$message({
                        type: "error",
                        duration: 1500,
                        message: '请先选择答案'
                    });
                    return false;
                }else{
                    answers = this.more_answer.split("");
                }
            }
            if(this.detail.type == 2){
                this.tian_answer = [];
                for(var i = 0;i<$('.tian_ipt').length;i++){
                    this.tian_answer.push($('.tian_ipt')[i].value)
                }
                if(this.tian_answer.length == 0){
                    this.$message({
                        type: "error",
                        duration: 1500,
                        message: '请先填写答案'
                    });
                    return false;
                }else{
                    answers = this.tian_answer;
                }
            }
            if(this.detail.type == 3){
                if(this.pan_answer.length == 0){
                    this.$message({
                        type: "error",
                        duration: 1500,
                        message: '请先选择答案'
                    });
                    return false;
                }else{
                    answers = this.pan_answer;
                }
            }
            this.start_answer = false;
            this.websocket.emit("user_answer",this.detail.id,JSON.stringify(answers));
        },
    },
       
};
</script>

<style scoped>
@import "../static/css/dati.css";
</style>
